import React from "react";
import NewBanner from "./components/NewBanner";
import SellersAndBuyers from "./components/SellersAndBuyers";
import HowItWorks from "./components/HowItWorks";
import AlyseiAI from "./components/AlyseiAI";
// Reuse current home page sections (same data, same code)
import Brands from "../LandingPage/component/Brands";
import NewAcademy from "./components/NewAcademy";
import NewTestimonials from "./components/NewTestimonials";
import Faq from "../LandingPage/component/Faq";
import FloatingBtns from "../LandingPage/component/FloatingBtns";
import SeoLanding from "../../components/Seo-helmet/Seo-Landing";

const NewHomePage = () => {
  return (
    <div className="font-sf-pro">
      <SeoLanding />

      {/* 1. New banner */}
      <NewBanner />

      {/* 2. Trusted-by slider — copied from current home page */}
      <Brands />

      {/* 3. Alysei for Sellers & Buyers — Figma image 2 + 3 */}
      <SellersAndBuyers />

      {/* 4. How Alysei Works — Figma image 4 */}
      <HowItWorks />

      {/* 5. AI Agent + Get a Demo — Figma image 5 */}
      <AlyseiAI />

      {/* 6. Alysei Academy (videos) — copied from current */}
      <NewAcademy />

      {/* 7. Testimonials — copied from current */}
      <NewTestimonials />

      {/* 8. FAQ — copied from current */}
      <Faq />

      {/* Newsletter intentionally removed per spec */}

      <FloatingBtns />
    </div>
  );
};

export default NewHomePage;
